const REGEX = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
const IOS_REGEX = /iPad|iPhone|iPod/i;
const SAFARI_REGEX = /^(?!.*(CriOS|FxiOS|EdgiOS)).*Safari/i;

/**
 * Need to check if navigator is available because of SSR
 * @see https://github.com/vercel/next.js/discussions/11013#discussioncomment-1320
 */
const navigatorAvailable = typeof window !== 'undefined' && navigator;

export const isDesktop = () => (navigatorAvailable ? !REGEX.test(navigator.userAgent) : undefined);
export const isMobile = () => (navigatorAvailable ? REGEX.test(navigator.userAgent) : undefined);
export const isIos = () => (navigatorAvailable ? IOS_REGEX.test(navigator.userAgent) : false);
export const isIosSafari = () => (navigatorAvailable ? isIos() && SAFARI_REGEX.test(navigator.userAgent) : false);
export const isNotEnumeratedMobile = () =>
  navigatorAvailable
    ? ((navigatorAvailable as Navigator & { userAgentData?: { mobile?: boolean } }).userAgentData?.mobile ?? false) ||
      navigatorAvailable.maxTouchPoints > 1
    : false;
